<header class="emptyHeaderMain"></header>
<div class="container">
  <div class="row">
    <div class="col-md-3 col-2"></div>
    <div class="col-md-6 col-8">
      <h1 *ngIf="!justSignedUp">Login</h1>
      <h1 *ngIf="justSignedUp">Successfully Signed Up!</h1>
    </div>
    <div class="col-md-3 col-2"></div>
  </div>
  <div class="row" *ngIf="justSignedUp">
    <div class="col-md-3 col-2"></div>
    <div class="col-md-6 col-8">
      Singup was successful! Use your email and password to login into
      WeDavinci!
      <br />
      <br />
    </div>
    <div class="col-md-3 col-2"></div>
  </div>
  <div class="row">
    <div class="col-md-3 col-2"></div>
    <div class="col-md-6 col-8">
      <form [formGroup]="loginForm">
        <div class="form-group mb-3">
          <label class="form-label" for="email-field">Email</label>

          <input
            id="email-field"
            type="email"
            class="form-control"
            formControlName="email"
            required />

          <div
            class="invalid-feedback"
            *ngIf="loginForm.get('email').getError('required')">
            Please enter your email.
          </div>
          <div
            class="invalid-feedback"
            *ngIf="loginForm.get('email').getError('email')">
            Please enter a valid email.
          </div>
        </div>

        <div class="form-group mb-3">
          <label class="form-label" for="password-field">Password</label>

          <input
            id="password-field"
            type="password"
            class="form-control"
            formControlName="password"
            required />

          <div
            class="invalid-feedback"
            *ngIf="loginForm.get('password').getError('required')">
            Please enter your password.
          </div>
        </div>

        <div *ngIf="showErrors" class="form-group mb-3 text-danger">
          <small>
            Failed to log in. Either the entered email address is wrong or the
            password does not match. Double check the spelling of the email
            address, and if you have forgot your password use the "Forgot
            Password" button below.
          </small>
        </div>

        <div>
          <button
            [disabled]="loginForm.invalid || this.pending"
            (click)="submitLogin()"
            class="btn btn-secondary btn-lg btn-login"
            type="submit">
            Login
          </button>
          <a style="margin: 0 32px" routerLink="/forgot-password">
            Forgot Password
          </a>
        </div>

        <hr />
        <div class="row">
          <div class="col-md-4 col-lg-3">
            <!--
            <oauth-buttons classes="btn-block"></oauth-buttons>
            -->
          </div>
        </div>
      </form>
    </div>
    <div class="col-md-3 col-2"></div>
  </div>
  <hr />
</div>
